import { render } from "./detail-master-blueprint.vue?vue&type=template&id=35a179ce&scoped=true"
import script from "./detail-master-blueprint.vue?vue&type=script&lang=js"
export * from "./detail-master-blueprint.vue?vue&type=script&lang=js"

import "./detail-master-blueprint.vue?vue&type=style&index=0&id=35a179ce&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a179ce"]])

export default __exports__